<template>
    <div>
      <van-popup
      v-model="isShowAll"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f9f9f9' }">
      <div class="add-pep">
        <van-nav-bar style="flex:1">
          <div slot="left" @click="close">
            <van-icon name="arrow-left" color="#333" size="19" />
          </div>
          <div slot="title">查看流转人员</div>
        </van-nav-bar>
        <div class="allPepWrap">
          <ul>
            <li class="onePep" v-for="(item, index) in allPepList" :key="index">
              <div class="onePepL" v-if="!item.Icon">
                {{showName(item.FullName)}}
                <img class="false_img" :src="trueImgUrl" alt="" v-if="item.IsSign">
              </div>
              <div class="onePepL" v-else>
                <img class="user-img"  :src="item.Icon + '?time =' + new Date().getTime()" alt="">
                <img class="false_img" :src="trueImgUrl" alt="" v-if="item.IsSign">
              </div>
              <div class="onePepR van-hairline--bottom">
                <span>{{item.FullName}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
const trueImgUrl = require("@/assets/operationalAnalysis/true_s.png");
export default {
  name:'AllPep',
  data(){
    return{
      trueImgUrl: trueImgUrl,
      mainUrl: this.xyMApi + '/base',
      
    }
  },
  props: {
    isShowAll: {
      type: Boolean
    },
    allPepList: {
      type: Array
    }
  },
  methods:{
    close(){
      this.$emit("listenToChildClose", false);
    },
    showName (name) {
      if (name !== null) {
        // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
        if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
          return name.length > 2 ? name.slice(-2) : name
        } else if (/^[A-Za-z]+$/g.test(name)) {
          // 纯英文名只展示两个字母
          return name.slice(0, 2)
        } else {
          // 其他
          return name.slice(0, 2)
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
.add-pep{
  margin-top: 10px;
  background: #fff;
  .onePep{
    height: 101px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    .onePepL{
      width: 76px;
      height: 76px;
      border-radius: 50%;
      background: #2980fe;
      margin: 0 28px 0 34px;
      text-align: center;
      line-height: 76px;
      color: #fff;
      font-size: 26px;
      position: relative;
      .user-img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        vertical-align: top;
      }
      .false_img {
        position: absolute;
        top: -8px;
        right: -8px;
      }
    }
    .onePepR{
      width: 618px;
      font-size: 30px;
      padding-right: 29px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span:first-child{
        color: #333;
      }
    }
  }
}
</style>

